/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-25 10:00:00                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-26 16:33:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * Validator
  * TechnicianForm: Create/edit technician form
*/

/* Imports */
import { t } from "i18next";
/***/

/* Services */
import LanguageSelect from "../language/LanguageSelect";
/***/

/* Validator */
export const UserFormValidator = {
  language: (e: EasyTech.Language) => e != null
};

/***/

/**
* TechnicianForm: Create/edit technician form 
* @param data - Data to edit
* @param onChange - On change event, trigger on field change
* @param onSubmit - On submit event, trigger enter key down on field
* @param submitted - is form submitted
*/
export default function UserForm({
  data,
  onChange,
  onSubmit,
  submitted
}: {
  data?: EasyTech.User,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean
}) {
  return (
    <>
      <div className="field">
        <label htmlFor="firstName">{t("First Name")}</label>
        <input type="text"
                value={data?.firstName || ""} disabled />
      </div>

      <div className="field">
        <label htmlFor="lastName">{t("Last Name")}</label>
        
        <input type="text"
                value={data?.lastName || ""} disabled />
      </div>
      
      <div className="field">
        <label htmlFor="email">{t("E-mail")}</label>
        
        <input type="text"
                value={data?.email || ""} disabled />
      </div>


      <div className="field">
        <label htmlFor="email">{t("Language")}</label>
        <LanguageSelect value={data?.language} onChange={(value) => onChange("language", value)} /> 
      </div>
    </>
  );
}
/***/
